
	// @ts-nocheck  (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
	/** Контрол выбора записи из всплывающего окна (которое является армом) */
	import modal from './../modal.vue'
	import ctrlMixins from './_mixins.js'
	import { UarmWizardField } from '@uarmSrc/types';
	import { PropType } from 'vue';
	import { unescapeSpecialChars } from './../utils.js' //@utils
	import { customTemplate, ctrlParamsForAll } from './_common-stuff.ts';

	const humanFieldName = 'name'; // поле которое будет выведено рядом с айди, для человекочитаемости

	export default {
		name: 'ctrl_popup_picker',
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Выбор записи',
			params: {
				useArmId: {
					name: 'АРМ',
					editType: 'armpicker'
				},
				customTemplate,
				multiPick: {
					name: 'Множественный выбор',
					tip: 'Внимание! Для использования множественного выбора у поля должны быть отмечены чекбоксы "Данные берутся из справочника" и "Связь со справочником через кросстаблицу" и заполнены соответствующие поля объектов БД',
					editType: 'checkbox'
				},
				popupFilterFieldsToPassInitialValues: {
					name: 'Поля для фильтра всплывающего АРМ',
					tip: `Какие поля фильтрации передавать в фильтр всплывающего АРМ. Значение: объект, где ключ - имя поля (dbcolname) в карточке основного АРМ, а значение - имя поля (dbcolname) фильтра всплывающего. В него приходит значение указанного поля основного)`,
					editType: 'manual',
				},
				...ctrlParamsForAll,
			},
			restrictions: {
				allowedClientTypes: ['NUMBER'],
			}
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: ''
			},
			/** Все поля данного АРМ в карточке, со значениями */
			card_meta: {
				type: Array as PropType<UarmWizardField[]>,
				default: (() => []),
			},
		},
		methods: {
			togglePopup: function(bShow) {
				//console.log(this.$options.components)
				/*if (bShow) {
					this.picked_ids_update(); // пересчитываем выбранные записи чтобы они были отмечены во всплывающем окне. Можно было бы компьютед, но так экономнее :)
				}*/
				this.$data.show_popup = !!bShow;
			},
			// Событие которое вызывается
			// - если тип выбора Единственный, то по нажатию кнопки "выбор"" в попапе
			// - если тип выбора Множественный, то по нажатию кнопки "применить выбор" в попапе
			onSelect: function(newVal) {
				var vm = this;
				vm.togglePopup(false);

				if (vm.$data.isMultiPick) {
					vm.c_value_picker = newVal; // newVal.map(function(){return el.ITEM_ID});
				}
				else {
					vm.$data.singleValuePickedInPopup = newVal.ITEM_ID;
					vm.c_value_picker = newVal.ITEM_ID;

					let value = ''
					if (newVal.hasOwnProperty(humanFieldName)) {
						value = newVal[humanFieldName]
					} else {
						const filedName = Object.keys(newVal).find(f => f.includes(humanFieldName))
						if (filedName) {
							value = newVal[filedName]
						}
					}

					const singleHumanTitle = unescapeSpecialChars(value);
					if (singleHumanTitle) {
						this.$data.singleHumanTitle = singleHumanTitle;

						const data = {
							...this.field_meta,
							value: {
								id: newVal.id,
								name: this.singleHumanTitle,
							}
						}
						this.$parent.$emit('update:value:full',data);
					}
				}
				vm.triggerInputEvent('onSelect', newVal);
				vm.mixin_saveEvent();
				vm.apply_flag = false; // для срабатывания повторного нажатия внешней кнопки Применить
			},
			multiPickedItems_remove: function(index){
				if (!this.$props.is_disabled) {
					// к сожалению другого способа заставить c_value_picker обновиться не придумал
					// кроме как копировать (slice) вэлью и пинать сеттер присвоением (=)
					// forceUpdate вероятно после добавления пинка не нужен
					var newValue = this.c_value_picker.slice();
					newValue.splice(index, 1);
					this.c_value_picker = newValue;
					this.$forceUpdate();
				}
				this.triggerInputEvent('multiPickedItems_remove', newValue);
				this.mixin_saveEvent(); // триггерим сохранение в списке
			},
			multiPickedItems_clear: function(){
				if (window.confirm('Подтвердите очистку значений')) {
					this.c_value_picker = [];
				}
				this.triggerInputEvent('multiPickedItems_clear', []);
				this.mixin_saveEvent(); // триггерим сохранение в списке
			},
			triggerInputEvent: function(evtType, newVal) {
				var fullValue;
				if (newVal instanceof Array) {
					fullValue = newVal.map(function(item) {
							return {
								id: item.id,
								name: item.name,
							}
						})
				}
				else {
					fullValue = {
						id: newVal.id,
						name: newVal.name,
					}
				}
				this.mixin_inputEvent({
					ctrlCode: this.$props.field_meta.ctrlCode,
					dbcolname: this.$props.field_meta.dbcolname,
					evtType,
					fullValue,
				});
			},
			/*picked_ids_update: function(){
				var ctrlValue = this.$props.value;
				var res;
				if (typeof ctrlValue === 'object' && ctrlValue.id) {
					res = [ctrlValue.id];
				}
				else if (ctrlValue instanceof Array) {
					res = ctrlValue.map(function(el){
						return el.id;
					});
				}
				else {
					res = [];
				}
				this.$data.picked_ids = res;
			},*/
		},
		components: {
			modal
		},
		computed: {
			c_value_picker: {
				get: function() {
					// Значения на вход поступают двух условных типов:
					// - single (единственное)
					// - multi (множественное, если параметр контрола multiPick === true)
					// ------------------------------------------------------------------
					// Значения на вход поступают из:
					// - сервера (обработчик контрола popup_picker)
					// - всплываюшего окна, см. p_list.vue, методы onItemSelect (для single) либо multiPickedItems_apply (для multi)
					// ------------------------------------------------------------------
					// Типы данных получаемых значений:
					// - пустая строка (если значения нет, например в фильтре)
					// - объект {id, name} если параметр контрола multiPick !== true
					// - массив объектов [{id, name}] если параметр контрола multiPick === true
					var ctrlValue = this.$props.value;
					var res;
					if (typeof ctrlValue === 'object' && ctrlValue !== null && ctrlValue.id) {
						res = ctrlValue.id;
					}
					else if (ctrlValue instanceof Array) {
						res = ctrlValue.slice().sort(nameComparator); // без slice случается PIRS2018-2422 !
					}
					else {
						res = ctrlValue;
					}
					return res;
				},
				set: function(newVal) {
					// console.log('c_value_picker SET', newVal)
					this.$emit('update:value', newVal);
				}
			},
			c_hasMultiValue: function(){
				return !!(this.c_value_picker && Object.keys(this.c_value_picker).length);
			},
			c_predefined_filter: {
				get: function() {
					const predefinedFilter = {};
					const popupFields = this.$props.field_meta?.ctrlParams?.popupFilterFieldsToPassInitialValues || {};

					for (const currentArmDbcolname in popupFields) {
						const cardField = this.$props.card_meta?.find?.(fi => fi.dbcolname === currentArmDbcolname);
						const cardValue = cardField?.rawValue || cardField?.value;
						const popupArmDbcolname = popupFields[currentArmDbcolname];
						// console.log(this.$props.field_meta.dbcolname, `=====`, this.$props.card_meta, cardField, cardValue, popupArmDbcolname, currentArmDbcolname);
						if (typeof cardValue !== 'undefined') {
							predefinedFilter[popupArmDbcolname] = cardValue;
						}
					}
					return predefinedFilter;
				}
			},
		},
		data: function() {
			var fieldMeta = this.$props.field_meta;
			var isMultiPick = fieldMeta.ctrlParams.multiPick;

			return {
				apply_flag: false, // Нажата кнопка Применить, уходит пропсом в p_list, который следит за его изменением
				isMultiPick,
				errText: '',
				arm_id: fieldMeta.ctrlParams.useArmId | 0, // this.c_ctrlParams.useArmId,
				pick_type: isMultiPick ? 'multi' : 'single',
				show_popup: false,
				singleHumanTitle: '',
				singleValuePickedInPopup: 0
			}
		},
		watch: {
			value: {
				handler: function(newVal, oldVal) {
					if (newVal !== this.$data.singleValuePickedInPopup) { // при ручном редактировании инпута ID стираем наименование
						this.$data.singleHumanTitle = '';
					}
					if (newVal && newVal.name) { // NB: name будет не значением колонки name если выбран кастомный формат
						this.$data.singleHumanTitle = newVal.name;
					}
				},
				immediate: true,
			}
		}
}

	function nameComparator(a, b) {
		if (a.name > b.name) {
			return 1;
		}
		if (a.name < b.name) {
			return -1;
		}
		return 0;
	}
